<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="任务转让"
        width="650px"
        append-to-body
        top="10vh"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" class="pr50">
                <el-form-item label="转让任务：">
                    <ul style="max-height: 30vh;overflow-y: auto;">
                        <li v-for="(item,index) in data" :key="index"
                        :title="item.task_name+'（'+item.task_number+ '）（当前归属：'+item.creator+ '）'">{{ item.task_name }}（{{item.task_number}}）（当前归属：{{item.creator}}）</li>
                    </ul>
                </el-form-item>
                <el-form-item label="接收人：" prop="user_id">
                    <ESelect
                        ref="searchInput"
                        v-model="formItem.user_id"
                        filterable
                        remote
                        clearable
                        :remote-method="getUserList"
                        :loading="searchLoading"
                        class="full-w"
                        placeholder="输入成员名称关键字搜索成员">
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </ESelect>
                    <p class="text-color-gray font12px mt4">转让表示将所选任务转至接收人，转让后当前归属人将无法查看与操作</p>
                </el-form-item>
            </el-form>
            <ErrTipModal ref="errTipModal" @cancel="handleCancel"/>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '转让(转让)'}">转让</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import API from '@/api/efficiencyTool/task.js';
    import ErrTipModal from '../../../modal/errorTipModal';
    import matomoFun from "@/utils/matomo.js";

    export default {
        name: "PushModal",
        components:{
            ErrTipModal,
        },
        props:{
            data:Array,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    user_id:'',
                },
                submitLoading:false,
                rules:{
                    user_id:[
                        { required: true, message: '请选择接收人', trigger: 'blur' },
                    ],
                },
                userList:[],
                searchLoading:false,
            }
        },
        methods:{
            handleClose() {
                matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '转让(取消)');
                this.dialogVisible = false;
                this.resetForm();
            },
            handleCancel(type){
                if(type === 'success' || type === 'warn') {
                    this.handleClose();
                    this.$emit('update');
                }
            },
            resetForm(){
                this.formItem.user_id= '';
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
                this.getUserList();
            },
            getUserList(query){
                if (query !== '') {
                    this.searchLoading = true;
                    API.getPushUserList({
                        search: query,
                    }).then(res => {
                        this.userList = res.data || [];
                        this.searchLoading = false;
                    }, (err) => {
                        console.log('getUserList error', err);
                        this.userList = [];
                        this.searchLoading = false;
                    });
                } else {
                    this.userList = [];
                }
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let taskIds = this.data.map(item=>item.task_id);
                        this.submitLoading = true;
                       API.pushTask({
                           user_id:this.formItem.user_id,
                           task_ids:taskIds.join(','),
                       },{ timeout: 60* 1000 }).then(res=>{
                           this.submitLoading = false;

                           let errData = res.data||{};
                           let errList = errData.error_auth||[];
                           if(errList.length>0){
                               this.$refs.errTipModal.showModal({
                                   title:res.info||'任务转让成功，邮件签名更新失败，请人工修改新负责人签名信息',
                                   subTitle:'',
                                   actionType:'pushTask',
                                   isConfirm:false,
                                   errList:errList,
                                   actionData:'',
                                   type: 'warn'
                               });
                           }else{
                                this.$message.success(res.info||'操作成功');
                                this.handleClose();
                                this.$emit('update');
                           }
                       },err=>{
                           let errData = err.data||{};
                           let errList = errData.error_auth||[];
                           if(err.code==403){
                               return this.$message.error(err.info||'请求异常');
                           }
                           if(errList.length>0){
                               this.$refs.errTipModal.showModal({
                                   title:err.info||'接收人无以下账户权限，无法转让',
                                   subTitle:'',
                                   actionType:'pushTask',
                                   isConfirm:false,
                                   errList:errList,
                                   actionData:'',
                                   type: 'error'
                               });
                           }else{
                               this.$message.error(err.info||'操作失败');
                           }


                           this.submitLoading = false;
                       });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
    }
</style>
